(function () {
  var wrapper = document.querySelector('[data-agency-inquiry]');
  if (!wrapper) return;
  var form = wrapper.querySelector('form');
  if (!form) return;

  var endpoint = wrapper.getAttribute('data-endpoint');
  var turnstileKey = wrapper.getAttribute('data-turnstile-key');
  var submitting = false;
  var submitted = false;
  var submitBtn = form.querySelector('[type="submit"]');
  var submitError = form.querySelector('[data-agency-submit-error]');
  var confirmation = wrapper.querySelector('[data-agency-confirmation]');
  var turnstileToken = '';
  var tokenWaiters = [];

  function value(name) {
    var field = form.elements.namedItem(name);
    return field && typeof field.value === 'string' ? field.value.trim() : '';
  }

  function deliverToken(token) {
    turnstileToken = token || '';
    var waiting = tokenWaiters;
    tokenWaiters = [];
    waiting.forEach(function (resolve) { resolve(turnstileToken); });
  }

  if (turnstileKey) {
    var slot = form.querySelector('[data-turnstile-slot]');
    var script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.onload = function () {
      if (!window.turnstile) return;
      window.turnstile.render(slot, {
        sitekey: turnstileKey,
        callback: deliverToken,
        'expired-callback': function () { turnstileToken = ''; },
        'error-callback': function () { deliverToken(''); }
      });
    };
    document.head.appendChild(script);
  }

  function waitForToken(maxMs) {
    if (!turnstileKey) return Promise.resolve('');
    if (turnstileToken) return Promise.resolve(turnstileToken);
    return new Promise(function (resolve) {
      var settled = false;
      function finish(token) {
        if (settled) return;
        settled = true;
        resolve(token || '');
      }
      tokenWaiters.push(finish);
      setTimeout(function () { finish(''); }, maxMs);
    });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (submitting || submitted) return;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    submitting = true;
    submitError.hidden = true;
    submitBtn.disabled = true;
    var restoreLabel = submitBtn.textContent;
    submitBtn.textContent = 'Sending…';

    var payload = {
      form_type: 'agency',
      name: value('contact[name]'),
      email: value('contact[email]'),
      agency_website: value('contact[Agency Website]'),
      travelers: value('contact[Number of Travelers in the Group]'),
      agency_dates: value('contact[Desired Tour Dates]'),
      transportation: value('contact[Will you require transportation?]'),
      accommodations: value('contact[Will you require accommodations?]'),
      locations: value("contact[Are there any specific locations you're interested in?]"),
      message: value('contact[body]'),
      website: value('website'),
      page: window.location.href,
      source: wrapper.getAttribute('data-source') || 'Agency Inquiry'
    };

    waitForToken(20000)
      .then(function (token) {
        payload.turnstile_token = token;
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('bad status ' + response.status);
        return response.json();
      })
      .then(function (result) {
        if (!result || result.ok !== true) throw new Error('inquiry not accepted');
        submitted = true;
        submitting = false;
        form.hidden = true;
        confirmation.hidden = false;
        confirmation.focus();
        if (!payload.website && window.ETTLeadTracking) window.ETTLeadTracking.record(form, 'agency');
      })
      .catch(function () {
        submitting = false;
        submitError.hidden = false;
        submitError.focus();
        submitBtn.disabled = false;
        submitBtn.textContent = restoreLabel;
      });
  });
})();
